export function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
}

// Last name = explicit surname field, else the last whitespace-separated token of displayName.
export function lastName(u = {}) {
  if (typeof u === "string") u = { displayName: u };
  if (u.surname) return String(u.surname);
  const parts = String(u.displayName || u.userPrincipalName || "").trim().split(/\s+/).filter(Boolean);
  return parts.length > 1 ? parts[parts.length - 1] : (parts[0] || "");
}

// Comparator to order employee dropdowns by last name (then full name as tiebreaker).
export function byLastName(a, b) {
  const c = lastName(a).toLowerCase().localeCompare(lastName(b).toLowerCase());
  return c !== 0 ? c : String(a.displayName || "").localeCompare(String(b.displayName || ""));
}

// First name = explicit givenName field, else the first whitespace-separated token of displayName.
export function firstName(u = {}) {
  if (typeof u === "string") u = { displayName: u };
  if (u.givenName) return String(u.givenName);
  return String(u.displayName || "").trim().split(/\s+/)[0] || "";
}


export const STATUS = {
  active: { label: "Active", cls: "bg-emerald-100 text-emerald-900 border-emerald-200" },
  disabled: { label: "Disabled", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  offboarding: { label: "Offboarding", cls: "bg-amber-100 text-amber-900 border-amber-200" },
  leaved: { label: "Leaved", cls: "bg-violet-100 text-violet-800 border-violet-200" },
};

export function statusMeta(s) {
  return STATUS[s] || STATUS.disabled;
}

export const ACTION_STATUS = {
  dispatched: "bg-emerald-100 text-emerald-900 border-emerald-200",
  done: "bg-emerald-100 text-emerald-900 border-emerald-200",
  finished: "bg-emerald-100 text-emerald-900 border-emerald-200",
  queued: "bg-blue-100 text-blue-900 border-blue-200",
  pending: "bg-blue-100 text-blue-900 border-blue-200",
  running: "bg-blue-100 text-blue-900 border-blue-200",
  scheduled: "bg-amber-100 text-amber-900 border-amber-200",
  waiting: "bg-amber-100 text-amber-900 border-amber-200",
  failed: "bg-red-100 text-red-900 border-red-200",
  error: "bg-red-100 text-red-900 border-red-200",
  stopped: "bg-red-100 text-red-900 border-red-200",
  cancelled: "bg-zinc-100 text-zinc-600 border-zinc-300",
  skipped: "bg-amber-100 text-amber-900 border-amber-200",
};

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString(undefined, {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return s;
  }
}

export function byId(list, key = "id") {
  const m = {};
  (list || []).forEach((x) => (m[x[key]] = x));
  return m;
}

export function syncAgo(iso, lang) {
  if (!iso) return "—";
  const secs = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  let n, unit;
  if (secs < 60) { n = secs; unit = "s"; }
  else if (secs < 3600) { n = Math.floor(secs / 60); unit = "m"; }
  else if (secs < 86400) { n = Math.floor(secs / 3600); unit = "h"; }
  else { n = Math.floor(secs / 86400); unit = "d"; }
  return lang === "de" ? `vor ${n}${unit}` : `${n}${unit} ago`;
}


// Localized workflow/job status label (falls back to the raw status if no i18n key exists).
export function statusLabel(status, t) {
  if (!status || !t) return status;
  const k = `st.${status}`;
  const v = t(k);
  return v === k ? status : v;
}
